import React, { useState } from 'react';
import { ExercisesArchive } from './exercises-archive';
import { ExercisesMetrics } from './exercises-metrics';
import { useSession } from '@/hooks/useSession';
import Onboarding from '@/components/custom/onboarding';
import { useTranslation } from 'react-i18next';
import { DashboardContent } from '@/layouts/dashboard';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useNavigate, useLocation } from 'react-router-dom';

export function Exercises({ path, uri }) {
  const navigate = useNavigate();
  const { selectedTab } = useLocation();
  const { t } = useTranslation();
  const { session } = useSession();
  const profiles = session?.user?.profileNames || (session?.user && session?.user['profile-names']) || [];
  const [showOnboarding, setShowOnboarding] = useState(false);

  const breadcrumbs = {
    title: 'Avaliações e Questões',
    nav: [
      {
        route: uri,
        name: 'Exercícios',
        isActive: true
      }
    ]
  };

  const BASE_ROUTE = '/questions';

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadcrumbs}
    >
      <Tabs defaultValue={selectedTab || 'apostilas'}>
        <TabsList>
          <TabsTrigger
            value="apostilas"
            onClick={() => navigate(`${BASE_ROUTE}/apostilas`)}
          >
            Exercícios
          </TabsTrigger>
          <TabsTrigger
            value="resultados-das-apostilas"
            onClick={() => navigate(`${BASE_ROUTE}/resultados-das-apostilas`)}
          >
            Resultados dos exercícios
          </TabsTrigger>
        </TabsList>

        <TabsContent
          value="apostilas"
          className="mt-5"
        >
          <ExercisesArchive selectedTab={selectedTab} />
        </TabsContent>
        <TabsContent
          value="resultados-das-apostilas"
          className="mt-5"
        >
          <ExercisesMetrics selectedTab={selectedTab} />
        </TabsContent>
      </Tabs>

      <Onboarding
        show={showOnboarding}
        setShowOnboarding={setShowOnboarding}
        onClose={() => setShowOnboarding(false)}
        path={path}
        profiles={profiles}
        title={t('onboarding.titleQuestionBooks')}
        videoId="0SrjT4xP2-g"
      />
    </DashboardContent>
  );
}
